<template>
  <div class="unbund-box">
    <WorkbenchTitle title="原系统账号解绑"></WorkbenchTitle>
    <div class="unbund-list">
      <template v-if="bindList.length">
        <template v-for="(item, index) in bindList">
          <div class="unbund-item" :key="index">
            <div class="unbund-info">
              <div :class="['unbund-icon', item.platform]"></div>
              <div class="unbund-txt">{{ item.platform_txt }}</div>
            </div>
            <div class="unbund-btn" @click="clickUnbind(item)">
              {{ item.role_txt }}账户解绑
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="unbund-no-item">暂无绑定账号</div>
      </template>
    </div>
  </div>
</template>
<script>
import WorkbenchTitle from "@/components/WorkbenchTitle";
import { fetchBindList, fetchDeleteBind } from "@/api/bind";
import { getToken } from "@/utils/auth";
import { PLATFORMS, ROLE_DIST } from "@/utils/enum";
import { isObject } from "@/utils/is";
export default {
  name: "Unbund",
  components: {
    WorkbenchTitle,
  },
  data() {
    return {
      common_token: "",
      bindList: [],
    };
  },
  mounted() {
    let common_token = getToken();
    this.common_token = common_token;
    this.getBindList();
  },
  methods: {
    getBindList() {
      const { common_token } = this;

      fetchBindList({
        common_token,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          isObject(data) && this.handleBindList(data);
        }
      });
    },
    handleBindList(data) {
      this.bindList = Object.keys(data).reduce((list, el) => {
        const elList = data[el];
        if (elList && elList.length) {
          let filterList = elList.reduce((tList, sysEl) => {
            sysEl = this.handleBindItem(sysEl, el);
            tList.push(sysEl);
            return tList;
          }, []);
          list = list.concat(filterList);
        }
        return list;
      }, []);
    },
    handleBindItem(item, platform) {
      item.platform = platform;
      item.platform_txt = PLATFORMS[platform].name;
      const role_info = ROLE_DIST[PLATFORMS[platform].role_enum];
      item.role_txt = role_info[item.role].name;

      return item;
    },
    clickUnbind(item) {
      const { common_token } = this;
      const { platform, id, platform_txt } = item;

      this.$confirm(`确认解除${platform_txt}绑定吗？`)
        .then(() => {
          fetchDeleteBind({
            platform,
            common_token,
            link_id: id,
          }).then((res) => {
            const { code } = res;
            if (code === 0) {
              this.$message({ message: "解绑成功！", type: "success" });
              this.getBindList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
